import { CHECK_RADIO_BOX_ALL_TYPE, DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import {
  WIDGET_ITEM_LINK_ID_TYPE,
  WIDGET_PRODUCTION_CONDITION_TYPE,
  WIDGET_TYPE,
} from '../../../constants/service/app/widgetConstants';
import { DISCOUNT_TYPE } from '../../../constants/service/app/productConstants';
import moment, { setDateFormat } from '../../../lib/moment';

/**
 *  위젯 정보 모델
 */
export const WIDGET_INFO_MODEL = {
  /**
   *  위젯 id
   */
  widgetId: null,
  /**
   *  위젯 타이틀
   */
  mainTitle: null,
  /**
   *  위젯 서브 타이틀 사용유무
   */
  isUsedSubTitle: false,
  /**
   *  위젯 서브 타이틀
   */
  subTitle: null,
  /**
   *  위젯 메모
   */
  memo: null,
  /**
   *  위젯 데이터 타입
   */
  widgetType: 0,
  /**
   *  위젯 레이아웃 타입
   */
  layoutType: 0,
  /**
   *  위젯 노출 기간 타입
   */
  exposureType: 0,
  /**
   *  위젯 노출 기간
   */
  exposurePeriod: {
    startDate: setDateFormat(moment(), DATE_FORMAT.FULL_DASH_FORMAT),
    endDate: setDateFormat(moment().add(7, 'day'), DATE_FORMAT.FULL_DASH_FORMAT),
  },
  /**
   *  위젯 버튼 사용유무
   */
  isUsedButton: false,
  /**
   *  위젯 버튼 텍스트
   */
  widgetButtonText: null,
  /**
   *  노출된 페이지 ID
   */
  linkedPageId: null,
  /**
   *  노출된 페이지 타이틀
   */
  linkedPageTitle: null,
  /**
   *  노출된 페이지 타입
   */
  linkedPageType: null,
  /**
   *  자동 추천 위젯 사용유무
   */
  isProductRecommend: false,
  /**
   * 기획전 연결 기능 활성화 여부
   */
  isActiveEventConnect: false,
  /**
   * 타임딜 쿠폰 사용 여부
   */
  isUseCoupon: false,
};

/**
 *  위젯 상품 조건 모델
 */
export const WIDGET_PRODUCT_CONDITION_MODEL = {
  /**
   *  위젯 상품 조건 타입
   */
  type: WIDGET_PRODUCTION_CONDITION_TYPE.REAL_PRICE,
  /**
   *  위젯 상품 할인 조건 타입
   */
  discountType: DISCOUNT_TYPE.FIXED_AMOUNT_DISCOUNT,
  /**
   *  위젯 상품 조건 최소값
   */
  minValue: 0,
  /**
   *  위젯 상품 조건 최대값
   */
  maxValue: 10000,
};

/**
 *  위젯 상품 레이아웃 정보 모델
 */
export const WIDGET_PRODUCT_LAYOUT_INFO_MODEL = {
  /**
   *  위젯 홈 상단 이미지
   */
  topImg: [],
  /**
   *  위젯 아이템 랜덤 노출 여부
   */
  isRandomItem: false,
  /**
   *  노출될 위젯 아이템 개수 SELECT LIST
   */
  exposureItemCountSelectList: [],
  /**
   *  위젯 아이템이 랜덤 노출일 경우
   *  노출될 위젯 아이템 개수
   */
  exposureItemCount: 4,
};

/**
 * 위젯 기획전 연결 모델
 */
export const WIDGET_CONNECTED_EVENT_INFO = {
  linkId: null,
  linkName: null,
  status: 0,
  eventPeriod: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  위젯 상세 모델
 */
export const WIDGET_DETAIL_MODEL = {
  /**
   *  위젯 상세 화면 상단 이미지
   */
  detailTopImg: [],
};

/**
 *  위젯 섹션 모델
 */
export const WIDGET_SECTION_MODEL = {
  /**
   *  위젯 아이템 타이틀 사용 여부
   */
  isUsedTitleItem: true,
  /**
   *  현재 선택된 탭
   */
  currentTabKey: null,
};

/**
 *  위젯 섹션 아이템 리스트 필터 옵션 모델
 */
export const WIDGET_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    /**
     *  상품 ID
     */
    productId: null,
    /**
     *  상품 명
     */
    productName: null,
    /**
     *  상품 1차 카테고리
     */
    mainCategory: null,
    /**
     *  상품 2차 카테고리
     */
    subCategory: null,
    /**
     *  브랜드
     */
    brandName: null,
    /**
     *  브랜드 Id
     */
    storeId: null,
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {
    /**
     *  브랜드명
     */
    storeName: null,
  },
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: {},
};

/**
 *  위젯 섹션 아이템 리스트 정렬 옵션 모델
 */
export const WIDGET_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    /**
     * 등록일
     */
    createDate: 'descend',
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {},
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: {},
};

/**
 *  위젯 아이템 링크 ID 리스트 필터 옵션 모델
 */
export const WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL]: {
    /**
     *  브랜드명
     */
    storeName: null,
  },
  /**
   *  기획전 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL]: {
    /**
     *  기획전 ID
     */
    eventId: null,
    /**
     *  제목
     */
    mainTitle: null,
    /**
     * 상태
     */
    status: null,
    /**
     * 기획전 본문
     */
    contents: null,
    /**
     * 메모
     */
    memo: null,
  },
  /**
   *  상품 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL]: {
    /**
     *  상품 ID
     */
    productId: null,
    /**
     *  상품 명
     */
    productName: null,
    /**
     *  상품 1차 카테고리
     */
    mainCategory: null,
    /**
     *  상품 2차 카테고리
     */
    subCategory: null,
    /**
     *  브랜드
     */
    brandName: null,
    /**
     *  브랜드 Id
     */
    storeId: null,
  },
  /**
   *  후기 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL]: {
    /**
     *  상품 후기 ID
     */
    reviewId: null,
    /**
     *  상품 후기 내용
     */
    content: null,
    /**
     *  브랜드 ID
     */
    storeId: null,
    /**
     *  브랜드명
     */
    storeName: null,
    /**
     *  상품 ID
     */
    productId: null,
    /**
     *  상품명
     */
    productName: null,
  },
  /**
   *  태그 상세 - 갤러리
   */
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY]: {
    tagId: null,
    tagName: null,
  },
  /**
   *  태그 상세 - 피드
   */
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED]: {
    tagId: null,
    tagName: null,
  },
};

/**
 *  위젯 아이템 링크 ID 리스트 정렬 옵션 모델
 */
const WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL_COMMON_DATA = [
  /**
   *  등록일
   */
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  위젯 아이템 링크 ID 리스트 정렬 옵션 모델
 */
export const WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL = {
  /**
   *  상품 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL]: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL_COMMON_DATA,
  /**
   *  후기 상세
   */
  [WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL]: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL_COMMON_DATA,
  /**
   *  태그 상세 - 갤러리
   */
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY]: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL_COMMON_DATA,
  /**
   *  태그 상세 - 피드
   */
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED]: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL_COMMON_DATA,
};

/**
 *  위젯 노출 기간 모델
 */
export const WIDGET_EXPOSURE_PERIOD_INFO_MODEL = {
  /**
   *  위젯 노출 시작일시
   */
  startDate: setDateFormat(moment().add(-7, 'day').startOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
  /**
   *  위젯 노출 종료일시
   */
  endDate: setDateFormat(moment().add(7, 'day').endOf('day'), DATE_FORMAT.FULL_DASH_FORMAT),
};

/**
 *  위젯 검색 키워드 모델
 */
export const WIDGET_SEARCH_KEYWORD = {
  type: null,
  value: null,
  text: '',
};

/**
 *  위젯 전체 리스트 검색 박스 모델
 */
export const WIDGET_ALL_LIST_SEARCH_DATA_MODEL = {
  /**
   *  위젯 데이터 타입
   */
  widgetType: null,
  /**
   *  위젯 레이아웃 타입
   */
  layoutType: null,
  /**
   *  키워드 검색
   */
  searchKeyword: WIDGET_SEARCH_KEYWORD,
  /**
   *  위젯 노출기간
   */
  exposurePeriod: {
    type: CHECK_RADIO_BOX_ALL_TYPE,
    period: WIDGET_EXPOSURE_PERIOD_INFO_MODEL,
  },
  /**
   *  위젯 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  위젯 전체 리스트 검색 옵션 모델
 */
export const WIDGET_ALL_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  위젯 데이터 타입
   */
  widgetType: null,
  /**
   *  위젯 레이아웃 타입
   */
  layoutType: null,
  /**
   *  키워드 검색
   */
  searchKeyword: WIDGET_SEARCH_KEYWORD,
  /**
   *  위젯 노출기간
   */
  exposurePeriod: {
    type: CHECK_RADIO_BOX_ALL_TYPE,
    period: {
      startDate: null,
      endDate: null,
    },
  },
  /**
   *  위젯 생성일
   */
  createDate: null,
};

/**
 *  서브 페이지 리스트 검색 박스 모델
 */
export const SUB_PAGE_LIST_SEARCH_DATA_MODEL = {
  /**
   *  페이지 제목
   */
  title: null,
  /**
   *  메모
   */
  memo: null,
};

/**
 *  서브 페이지 리스트 검색 옵션 모델
 */
export const SUB_PAGE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  페이지 제목
   */
  title: null,
  /**
   *  메모
   */
  memo: null,
};
